import { render, staticRenderFns } from "./FlightAct.vue?vue&type=template&id=28609bfb&"
import script from "./FlightAct.vue?vue&type=script&lang=js&"
export * from "./FlightAct.vue?vue&type=script&lang=js&"
import style0 from "./FlightAct.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports